import React from 'react';
import { View, StyleSheet } from 'react-native';

import R from 'common/res/R';

const styles = StyleSheet.create({
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: R.spacing.xs,
  },
});

export default ({ children, ...props }) => (
  <View style={styles.buttonContainer}>{children}</View>
);
